/*!
=========================================================
* Black Dashboard React v1.2.0
=========================================================
* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useState, useEffect, useRef, useCallback } from "react";
import NotificationAlert from "react-notification-alert";
import { notify, getCookie, addPlaylist, addDefaultSrc, descStyle, getThumbnailUrl } from "./Utils";
import { getCookie as getCookieUtil } from "./Utils";
import VisibilitySensor from "react-visibility-sensor";
import { getAnalytics, logEvent } from "firebase/analytics";
// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardBody,
  Label,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  UncontrolledTooltip,
  CardText,
} from "reactstrap";

// TODO CLEANUP: Remove deprecated config4js.js imports (ZAI-68)
// config4js.js is deprecated in favor of service_config.js
// Use window.getBackendUrl() and window.getAuthUrl() instead
// See: https://tadepalli.atlassian.net/browse/ZAI-68
// import { serverUrl } from '../config4js.js';
// import { altServerUrl, exploreBackendUrl } from '../config4js.js';

// Use service_config.js instead (loaded globally via index.html)
const serverUrl = window.getBackendUrl();
const altServerUrl = window.getAuthUrl();
const exploreBackendUrl = window.getAuthUrl();
// import { isTemplateSpan } from "typescript";

function Explore(props) {
  const [modal, setModal] = React.useState(false);
  const [programs, setPrograms] = React.useState([]);
  
  const [allFilter, setAllFilter] = React.useState(false);
  const [allOpacity, setAllOpacity] = React.useState(0.0);
  const [roboticsFilter, setRoboticsFilter] = React.useState(false);
  const [roboticsOpacity, setRoboticsOpacity] = React.useState(0.0);
  const [codingFilter, setCodingFilter] = React.useState(false);
  const [codingOpacity, setCodingOpacity] = React.useState(0.0);
  const [physicsFilter, setPhysicsFilter] = React.useState(false);
  const [physicsOpacity, setPhysicsOpacity] = React.useState(0.0);
  
  const [search, setSearch] = React.useState("");
  const [bottom, setBottom] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [bottomLoad, setBottomLoad] = React.useState(false);
  const [lists, setLists] = React.useState([]);
  const [checkedState, setCheckedState] = React.useState(
    new Array(lists.length).fill(false)
  );
  const [projectID, setProjectID] = React.useState("");
  const [doneFetching, setDone] = React.useState(false);
  const notificationAlertRef = React.useRef(null);
  
  // Check authentication status on mount (for new windows/tabs)
  // Similar to StudioPage - ensures Redux state is synced from cookies/localStorage
  useEffect(() => {
    const checkAuth = () => {
      const token = getCookie("ziroatoken");
      const userId = localStorage.getItem("google_user_id");
      const loggedIn = localStorage.getItem("loggedin");
      
      console.log("🔍 Explore Auth Check (new window):", { 
        token: !!token, 
        userId, 
        loggedIn,
        hostname: window.location.hostname,
        hasCookie: !!token,
        hasLocalStorage: !!userId && loggedIn === 'true'
      });
      
      // If we have auth indicators but Redux isn't synced, sync it
      if (token && userId && loggedIn === 'true' && props.auth !== 1) {
        // Sync with Redux - important for new windows
        const userPicture = localStorage.getItem("profile_image_url") || '';
        props.dispatch({ type: "LOGIN" });
        props.dispatch({ type: "USERID", id: userId });
        props.dispatch({ type: "USERIMG", url: userPicture });
        console.log('✅ Synced existing auth to Redux store in Explore (new window)');
      }
    };

    // Small delay to ensure cookie is accessible
    const timeoutId = setTimeout(checkAuth, 100);
    return () => clearTimeout(timeoutId);
  }, [props.auth, props.dispatch]);
  
  useEffect(() => {
    setCheckedState(new Array(Object.keys(lists).length).fill(false));
  }, [lists]);

  function sessionStorageSet(key, value) {
    //console.log(key, value, "stringified: ", JSON.stringify(value));
    if (typeof value === "string") {
      sessionStorage.setItem(key, value);
      return;
    }
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  function sessionStorageAppend(key, value) {
    //console.log("Local Storage Append", key, value);
    var storedValue = JSON.parse(sessionStorage.getItem(key));
    //console.log(typeof storedValue);
    //console.log(storedValue);
    // Handle case where session storage is empty/null (race condition on page load)
    if (!storedValue || !Array.isArray(storedValue)) {
      storedValue = [];
    }
    storedValue.push(value);
    sessionStorageSet(key, JSON.stringify(storedValue));
  }

  function sessionStorageGet(key) {
    var item = sessionStorage.getItem(key);
    if (item == null || item[0] !== "[") {
      return item;
    }
    return JSON.parse(item);
  }

  useEffect(() => {
    loadMoreProjects("", codingFilter, physicsFilter, roboticsFilter, false);
    toggleAllBadge();
  }, [codingFilter, physicsFilter, roboticsFilter]);

  useEffect(() => {
    // console.log("loading", loading, "bottom", bottom);
    if (!loading && bottom) {
      //console.log("Load more projects");
      loadMoreProjects(
        sessionStorageGet("cursor"),
        codingFilter,
        physicsFilter,
        roboticsFilter,
        true
      );
    }
  }, [programs, bottom, loading]);

  function loadMoreProjects(
    mycursor,
    codingTag,
    physicsTag,
    roboticsTag,
    fromBottom
  ) {
    

    var curss = sessionStorageGet("usedCursors");
    if (!fromBottom) {
      setPrograms([]);
      mycursor = "";
      sessionStorageSet("cursor", "");
      sessionStorageSet("usedCursors", []);
    } else if (curss && curss.includes(mycursor)) {
      // console.log("Already used cursor", mycursor, curss);
      setLoading(false);
      return;
    }

    // console.log(
    //   "Loading more projects with cursor: ",
    //   mycursor,
    //   "Used cursors:",
    //   curss
    // );

    console.log("Filter Project: " + serverUrl);
    var xhr = new XMLHttpRequest();
    // construct API endpoint - use exploreBackendUrl which routes to auth service (has assistantProjectType filter)
    // Production: ziroaidev.appspot.com | Dev: auth-dot-ziro-ai-one-dev.uc.r.appspot.com
    var apiEndpoint = exploreBackendUrl + "/filterprojects";
    console.log("Explore API Endpoint: " + apiEndpoint);
    //xhr.open("POST", "https://zirostudio.appspot.com/filterprojects");
    xhr.open("POST", apiEndpoint);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    setLoading(true);
    xhr.onload = function () {
      logEvent(getAnalytics(), 'loaded_more_explore_projects')
      // console.log("Loaded more projects successfully: " + xhr.responseText);
      const obj = JSON.parse(xhr.responseText);
      const additionalProgs = obj.projects;
      const currCursor = obj.cursor;
      sessionStorageSet("cursor", currCursor); //update value of cursor

      if (fromBottom) {
        setBottomLoad(false);
        //if user requested more projects from bottom of page, concat programs array instead of overwriting
        setPrograms((programs) => [...programs, ...additionalProgs]);
      } else {
        setPrograms(additionalProgs);
        //setPrograms((programs) => [...programs, ...additionalProgs]);
      }
      setLoading(false);

      if (currCursor == "") {
        setDone(true);
      }

      /*if (currCursor != "" && additionalProgs.length < 6) {
        //if there are more projects to load, load them
        console.log("Autoloading more");
        loadMoreProjects(currCursor, codingTag, physicsTag, roboticsTag, true);
      }*/
    };

    sessionStorageAppend("usedCursors", mycursor);

    xhr.send(
      JSON.stringify({
        coding_tag: codingTag,
        physics_tag: physicsTag,
        robotics_tag: roboticsTag,
        search_string: search,
        cursor: mycursor,
      })
    );
    //console.trace()
  }

  const toggleBadge = (tp) => {
    if (tp === "coding") {
      setCodingFilter((codingFilter) => codingFilter);
      setCodingOpacity(0.0);
    } else if (tp === "physics") {
      setPhysicsFilter((physicsFilter) => physicsFilter);
      setPhysicsOpacity(0.0);
    } else if (tp === "robotics") {
      setRoboticsFilter((roboticsFilter) => roboticsFilter);
      setRoboticsOpacity(0.0);
    } else if (tp === "all") {
      setAllFilter((allFilter) => allFilter);
      setAllOpacity(0.0);
    }

    setCodingFilter(false);
    setPhysicsFilter(false);
    setRoboticsFilter(false);
    setAllFilter(false);

    setCodingOpacity(0.0);
    setPhysicsOpacity(0.0);
    setRoboticsOpacity(0.0);
    setAllOpacity(0.0);
    
  };

  const toggleAllBadge = () => {
    if (
      codingFilter === false &&
      physicsFilter === false &&
      roboticsFilter === false
    ) {
      setAllOpacity(0.0);
    } else {
      setAllOpacity(0.0);
    }
  };

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  const prevAuth = usePrevious(props.auth);

  useEffect(() => {
    if (prevAuth === undefined && prevAuth != props.auth) {
      sessionStorageSet("cursor", "");
      sessionStorageSet("usedCursors", []);
      // fetchProjects();
      //console.log("LOADING PROJECTS")
      loadMoreProjects(
        sessionStorageGet("cursor"),
        codingFilter,
        physicsFilter,
        roboticsFilter,
        false
      );
    }
  });

  function addToPlaylist(fileID) {
    var id_token = getCookie("ziroatoken");
    addPlaylist(id_token, fileID, lists, addToPlayListCallback);
    setProjectID(fileID);
  }

  function addToPlayListCallback(res){
    setCheckedState(res);
    toggleModal();
  }

  const handleOnChange = (position) => {
    const updatedCheckedState = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    setCheckedState(updatedCheckedState);
  };

  function toggleModal() {
    setModal(!modal);
  }

  useEffect(() => {
    if (props.auth == 1){
      fetchLists(props.auth);
    }
  }, [props.auth]);

  useEffect(() => {
    logEvent(getAnalytics(), 'on_explore_page')
  }, []);

  function fetchLists(pauth) {
    //plural fetch lists. the 'lists' hooks should be an array of the user's created lists, all with their own info, args should only be auth/id token/userID
    if (props.auth !== 1) {
      return;
    }
    // Get session_id from cookie or localStorage (with fallback)
    var sessionId = getCookie("ziroatoken");
    
    // If cookie is empty, check localStorage for session_id as backup
    if (!sessionId) {
      sessionId = localStorage.getItem('ziro_session_id');
      if (sessionId) {
        console.log("🔍 Cookie empty, using session_id from localStorage (backup)");
      }
    }
    
    if (!sessionId) {
      console.error("❌ No session_id found for fetchUserPlaylists - user needs to log in");
      return;
    }
    
    // Verify it's actually a session_id (UUID format), not a legacy JWT
    const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
    if (!isSessionId) {
      console.error("❌ Invalid session format - expected UUID session_id, found:", sessionId ? sessionId.substring(0, 20) + "..." : "empty");
      console.error("💡 User needs to re-authenticate to get a new session_id");
      return;
    }
    
    console.log("Fetch User Playlist: " + serverUrl);
    var xhr = new XMLHttpRequest();
    
    // Always use session_id parameter (JWT support removed)
    var apiEndpoint = serverUrl + "/fetchuserplaylists?session_id=" + sessionId;
    console.log(apiEndpoint);
    xhr.open(
      "GET",
      apiEndpoint //"https://zirostudio.appspot.com/fetchuserplaylists?authtoken=" + id_token
    );

    xhr.onload = function () {
      //console.log("Fetched lists: " + xhr.responseText);
      if ("status" in JSON.parse(xhr.responseText)) {
        console.log("Failed to fetch lists");
        return;
      }
      setLists(JSON.parse(xhr.responseText));
    };

    xhr.send();
  }

  //TODO: modify backend to handle adding one project to multiple lists
  function addProjectToPlaylist(checkedState, projID) {
    //loop through checkedState to see which ones were selected
    let playlistIds = [];

    for (let i = 0; i < checkedState.length; i++) {
      if (checkedState[i] == true) {
        playlistIds.push(lists[i].playlist_id);
      }
    }

    if (playlistIds.length > 0) {
      // Get session_id from cookie or localStorage (once for all requests)
      var sessionId = getCookie("ziroatoken");
      if (!sessionId) {
        sessionId = localStorage.getItem('ziro_session_id');
      }
      // Verify it's a session_id (UUID format)
      const isSessionId = sessionId && sessionId.includes('-') && sessionId.length === 36 && !sessionId.includes('.');
      if (!isSessionId) {
        console.error("❌ Explore.addToPlayListCallback: No valid session_id found");
        return;
      }
      
      for (let i = 0; i < playlistIds.length; i++) {
        console.log("Edit Play List: " + serverUrl);
        var xhr = new XMLHttpRequest();
        // Use session_id parameter (backend only accepts session_id now)
        var apiEndpoint = serverUrl + "/editplaylist?session_id=" + sessionId;
        console.log(apiEndpoint);
        xhr.open(
          "POST",
          apiEndpoint //"https://zirostudio.appspot.com/editplaylist?authtoken=" + id_token
        );
        xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

        xhr.onload = function () {
          // console.log("Added project to playlist(s): " + xhr.responseText);
          notify(
            "Added project to list(s) successfully.",
            notificationAlertRef
          );
          toggleModal();
        };

        xhr.send(
          JSON.stringify({
            playlist_id: playlistIds[i],
            file_id: projID,
            operation: true,
          })
        );
      }
    }
    playlistIds = [];
  }

  const handleSearch = (evt) => {
    setSearch(evt.target.value);
  };

  useEffect(() => {
    if(search){
      loadMoreProjects("", codingFilter, physicsFilter, roboticsFilter, false);
      // setAllFilter(false);
      // setAllOpacity(0.6);
    } else if(!search && prevAuth == props.auth) { // to prevent cursor loading again on startup
      loadMoreProjects("", codingFilter, physicsFilter, roboticsFilter, false);
      setAllFilter(false);
      setAllOpacity(0.0);
    }
  }, [search]);

  // function makeSearch(evt) {
  //   console.log(search);
  //   if(!search){
  //     console.log("empty string?")
  //     loadMoreProjects("", codingFilter, physicsFilter, roboticsFilter, false);
  //   }
  //   loadMoreProjects("", codingFilter, physicsFilter, roboticsFilter, false);
  // }

  const checkEnterSearch = (evt) => {
    if (evt.keyCode === 13) {
      handleSearch(evt);
    }
  };

  function onVisibilityChange(isVisible) {
    //console.log("onVisibilityChange", isVisible);
    if (
      isVisible
      //sessionStorageGet("cursor") !== "" &&
      //sessionStorageGet("usedCursors").length > 0
    ) {
      setBottom((bottom) => true);
      setBottomLoad(
        sessionStorageGet("cursor") != "" ||
          sessionStorageGet("usedCursors").length == 0
      );
    } else {
      setBottom((bottom) => false);
      setBottomLoad(false);
    }
  }

  return (
    <>
      <div className="react-notification-alert-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <div className="content">
        <Row>
          <Col md="12">
            <Card
              className="card-tasks"
              style={{ height: "100%", "overflow-x": "hidden" }}
            >
              <CardHeader>
                <Row>
                  <Col>
                    <h2 className="title d-inline">Community Projects</h2>
                  </Col>

                  <Col md={3}>
                    <InputGroup className="no-border" style={{ display: 'none' }}>
                      <Input
                        placeholder="Search for projects..."
                        onBlur={handleSearch}
                        onKeyDown={checkEnterSearch}
                      />
                      <InputGroupAddon addonType="append">
                        <Button
                          color="secondary"
                          size="sm"
                          className="tim-icons icon-zoom-split"
                          // onClick={makeSearch}
                        ></Button>
                      </InputGroupAddon>
                    </InputGroup>

                    <Badge
                      color="danger"
                      style={{
                        marginTop: 10,
                        float: "right",
                        marginLeft: 5,
                        opacity: roboticsOpacity,
                        cursor: "pointer",
                      }}
                      onClick={() => toggleBadge("robotics")}
                    >
                      Robotics
                    </Badge>

                    <Badge
                      color="primary"
                      style={{
                        marginTop: 10,
                        float: "right",
                        marginLeft: 5,
                        opacity: physicsOpacity,
                        cursor: "pointer",
                      }}
                      onClick={() => toggleBadge("physics")}
                    >
                      Physics
                    </Badge>

                    <Badge
                      color="warning"
                      style={{
                        marginTop: 10,
                        float: "right",
                        marginLeft: 5,
                        opacity: codingOpacity,
                        cursor: "pointer",
                      }}
                      onClick={() => toggleBadge("coding")}
                    >
                      Coding
                    </Badge>

                    <Badge
                      color="default"
                      style={{
                        marginTop: 10,
                        float: "right",
                        marginLeft: 5,
                        opacity: allOpacity,
                        cursor: "pointer",
                      }}
                      onClick={() => toggleBadge("all")}
                    >
                      All
                    </Badge>
                  </Col>
                </Row>
                <br></br>
              </CardHeader>

              <CardBody>
                <Row>
                  {programs.map((item) => {
                    return (
                      <Col lg={4} style={{ marginBottom: 20 }}>
                        <Card
                          className=""
                          style={{ height: "100%", marginBottom: 0 }}
                        >
                          <Link
                            to={{
                              pathname:
                                "/studio?code=" +
                                item["file_id"],
                            }}
                            target="_blank"
                          >
                            <img
                              className="img-fluid"
                              onError={addDefaultSrc}
                              src={getThumbnailUrl(item["file_id"])}
                              alt={"Thumbnail"}
                            ></img>
                          </Link>

                          <Row style={{ marginTop: -45, marginLeft: -7 }}>
                            <Col md="12">
                              <Link
                                to={{
                                  pathname: "/studio?code=" + item["file_id"],
                                }}
                                target="_blank"
                              >
                                <Button
                                  className="btn-round btn-icon btn-clear"
                                  style={{
                                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                                    backgroundImage: "",
                                  }}
                                  id={"toStudio" + item["file_id"]}
                                >
                                  <i
                                    className="tim-icons icon-double-right"
                                    color="white"
                                  />
                                </Button>
                                <UncontrolledTooltip
                                  placement="top"
                                  target={"toStudio" + item["file_id"]}
                                  style={{ pointerEvents: "none" }}
                                >
                                      Proceed to Studio
                                    </UncontrolledTooltip>
                              </Link>

                              <Link
                                to={
                                    "/project-info?id=" + item["file_id"]
                                }
                              >
                                <Button
                                  className="btn-round btn-icon btn-clear"
                                  style={{
                                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                                    backgroundImage: "",
                                  }}
                                  id={"moreInfo" + item["file_id"]}
                                >
                                  <i style={{marginBottom: 10}} className="fa fa-info" />
                                </Button>
                                <UncontrolledTooltip
                                  placement="top"
                                  target={"moreInfo" + item["file_id"]}
                                  style={{ pointerEvents: "none"}}
                                >
                                  More Information
                                </UncontrolledTooltip>
                              </Link>

                              <div
                                style={{
                                  fontSize: "larger",
                                  marginTop: 0,
                                  marginRight: 5,
                                  color: "#208cfc",
                                  float: "right",
                                  transform: "translate(0px, 20px)",
                                }}
                              >
                                <p
                                  className="fas fa-star"
                                  style={{ marginRight: 3, color: "#208cfc" }}
                                ></p>
                                {item["num_star"]}
                              </div>

                              {props.auth === 1 ? (
                              <>
                                <Button
                                  className="btn-round btn-icon btn-clear"
                                  style={{
                                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                                    backgroundImage: "",
                                  }}
                                  id={"playlist" + item["file_id"]}
                                  onClick={() => {
                                    addToPlaylist(item["file_id"]);
                                  }}
                                >
                                  <i className="fas fa-plus" />
                                </Button>
                                <UncontrolledTooltip
                                  placement="top"
                                  target={"playlist" + item["file_id"]}
                                  style={{ pointerEvents: "none" }}
                                >
                                  Add to List
                                </UncontrolledTooltip>
                              </>
                              ) : null }
                               {/* Block flag for project cards */}
                                                   
                              <div
                                                  
                                style = {{
                                  display: item["blockly"] ? "inline-block" : "none",
                                }}
                                
                                >
                                  <Button
                                  className="btn-round btn-icon btn-clear"
                                  style={{
                                    backgroundColor: "rgba(0, 0, 0, 0.3)",
                                    backgroundImage: "",
                                    
                                  }}
                                  id = {"BC" + item["fileID"]}
                                >
                                <p> <i
                                    class="fa-solid fa-b"
                                    
                                  /> {item["blockly"] ? "B" : ""}
                                </p></Button>
                                  
                              </div>

                              <Modal
                                isOpen={modal}
                                toggle={toggleModal}
                                style={{ paddingBottom: 10 }}
                                /*backdropClassName={"modal-dark"}*/
                                size="sm"
                              >
                                <ModalHeader>
                                  <h4
                                    className="modal-title"
                                    id="exampleModalLabel"
                                  >
                                    Save to...
                                  </h4>
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-hidden="true"
                                    onClick={toggleModal}
                                  >
                                    <i className="tim-icons icon-simple-remove" />
                                  </button>
                                </ModalHeader>
                                {lists.length === 0 && props.auth === 1 ? (
                                  <Row>
                                    <Col>
                                      <p style={{color: "#000", marginLeft: 25, marginTop: 15}}>
                                        You don't have any lists. Create a list 
                                        <a href="/user-view"> here!</a>
                                      </p>
                                    </Col>
                                  </Row>
                                )
                                : null}
                                {lists.map((key, index) => {
                                  return (
                                    <>
                                      <ModalBody
                                        style={{
                                          padding: 5,
                                          paddingLeft: 20,
                                          paddingBottom: -10,
                                        }}
                                      >
                                        <FormGroup check>
                                          <Label
                                            check
                                            htmlFor={`custom-checkbox-${index}`}
                                          >
                                            <Input
                                              type="checkbox"
                                              id={`custom-checkbox-${index}`}
                                              name={key.title}
                                              value={key.title}
                                              checked={checkedState[index]}
                                              onChange={() =>
                                                handleOnChange(index)
                                              }
                                            />
                                            {key.title}
                                            <span className="form-check-sign">
                                              <span className="check"></span>
                                            </span>
                                          </Label>
                                        </FormGroup>
                                      </ModalBody>
                                    </>
                                  );
                                })}

                                <ModalFooter>
                                {lists.length === 0 ? (
                                    <Button
                                    color="success"
                                    className="animation-on-hover"
                                    style={{
                                      marginLeft: 24,
                                      marginBottom: 16,
                                      marginTop: 15,
                                    }}
                                    disabled
                                  >
                                    Add to List
                                  </Button>
                                  )
                                  : <Button
                                    color="success"
                                    className="animation-on-hover"
                                    style={{
                                      marginLeft: 24,
                                      marginBottom: 16,
                                      marginTop: 15,
                                    }}
                                    onClick={() =>
                                      addProjectToPlaylist(
                                        checkedState,
                                        projectID
                                      )
                                    }
                                  >
                                    Add to List
                                  </Button>}
                                </ModalFooter>
                              </Modal>
                            </Col>
                          </Row>

                          <CardBody>
                            <CardText />
                            <div className="author">
                              <Link
                                to={{
                                  pathname:
                                    "/studio?code=" +
                                    item["file_id"],
                                }}
                                target="_blank"
                              >
                                <h3 style={{ marginBottom: 0 }}>
                                  {item["title"]}
                                </h3>
                              </Link>
                              <p className="description" style={descStyle}>
                                {item["description"]}
                              </p>
                            </div>

                            <div style={{ marginTop: 5 }}>
                              {"physics_tag" in item &&
                                item["physics_tag"] == true && (
                                  <Badge color="success">physics</Badge>
                                )}
                              {"coding_tag" in item &&
                                item["coding_tag"] == true && (
                                  <Badge color="warning">coding</Badge>
                                )}
                              {"robotics_tag" in item &&
                                item["robotics_tag"] == true && (
                                  <Badge color="danger">robotics</Badge>
                                )}
                              {"other_tags" in item &&
                                item["other_tags"].map(
                                  (tag) =>
                                    tag != "physics" &&
                                    tag != "coding" &&
                                    tag != "robotics" && (
                                      <Badge color="info">{tag}</Badge>
                                    )
                                )}
                            </div>

                            <div>
                              <Row style={{ marginTop: 15 }}>
                                <div
                                  className="author"
                                  style={{ marginLeft: 15 }}
                                >
                                  <a
                                    href="#pablo"
                                    onClick={(e) => e.preventDefault()}
                                  >
                                    <img
                                      alt="..."
                                      className="avatar"
                                      src={item["img_url"]["img_url"]}
                                    />
                                  </a>
                                </div>
                                <a
                                  className="description"
                                  style={{
                                    fontSize: "1rem",
                                    marginLeft: 10,
                                    marginTop: 3,
                                  }}
                                >
                                  {item["profile"] != null
                                    ? item["profile"]["first_name"] +
                                      " " +
                                      item["profile"]["last_name"]
                                    : ""}
                                </a>
                              </Row>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>

                <VisibilitySensor
                  onChange={onVisibilityChange}
                  scrollCheck={true}
                >
                  <div> &nbsp; </div>
                </VisibilitySensor>

                {bottomLoad || loading ? (
                  <>
                    <br></br>
                    <Row>
                      <Col>
                        <Spinner
                          animation="border"
                          color="info"
                          style={{
                            padding: 0,
                            margin: 7,
                            marginLeft: 15,
                          }}
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  <br></br>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(Explore);
